import { render } from "./menu.svg?vue&type=template&id=831fac60"
const script = {}

import exportComponent from "C:\\Users\\craig\\Documents\\Websites\\lyle-scott\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__